import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICustomer, CustomerType } from 'next-common';
interface CustomerState {
  type: CustomerType;
  customer: ICustomer;
}

const initialState: CustomerState = {
  type: CustomerType.PRIVATE,
  customer: null,
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerType: (state, action: PayloadAction<CustomerType>) => {
      state.type = action.payload;
    },
    setCustomer: (state, action: PayloadAction<ICustomer>) => {
      state.customer = action.payload;
    },
  },
});

export const { setCustomer, setCustomerType } = customerSlice.actions;
export default customerSlice.reducer;
